export const LOADING_SEARCH_RESULTS_COUNT = 3;
export const LOADING_MY_LIST_COUNT = 5;
export const LOADING_TIMEOFF_DAYS = 5;
